export enum DoctorNavPermissions {
  GO_TO_ADD_SIGNATURE = 'GO_TO_ADD_SIGNATURE',
  GO_TO_HOME = 'GO_TO_HOME',
  GO_TO_REVIEW = 'GO_TO_REVIEW',
  GO_TO_RECOMMENDATION_REGISTER = 'GO_TO_RECOMMENDATION_REGISTER'
}
